import { Box, Text } from '@chakra-ui/react'
import { FC, useEffect, useState } from 'react'
import { OptionsType } from 'react-select'
import { AsyncPaginate } from 'react-select-async-paginate'

import { FilterProps } from '@base/@types/components/Shared/Filter'

interface IOptionsSelectedProps {
  label: string
  value: string | number
}

const SelectAsyncPaginate: FC<FilterProps> = ({
  label = '',
  options = [],
  value = [],
  isMulti = false,
  isLoading = false,
  isDisabled = false,
  isRequired = false,
  isFollowUp = false,
  limit,
  onChange = null
}) => {
  const [_query, setQuery] = useState('')
  useEffect(() => {}, [])

  const loadOptions = (searchQuery: any, loadedOptions: any, { page }: any) => {
    let newArray = []
    if (!searchQuery) {
      newArray = paginate(options, 10, page)
    } else {
      const searchLower = searchQuery.toLowerCase()

      newArray = paginate(
        options.filter(({ label }) =>
          label.toLowerCase().includes(searchLower)
        ),
        10,
        page
      )
    }
    const hasMore = newArray.length > 1
    return {
      options: newArray,
      hasMore: hasMore,
      additional: {
        page: searchQuery ? 2 : page + 1
      }
    }
  }

  function paginate(array: any[], pageNumber: number, page: number) {
    // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
    return array.slice((page - 1) * pageNumber, page * pageNumber)
  }

  const handleOnChange = (
    values: IOptionsSelectedProps | OptionsType<IOptionsSelectedProps>
  ) => {
    onChange &&
      onChange(
        limit && Array.isArray(values) ? values!.slice(0, limit) : values
      )
  }
  const handleFilterSelect = (inputValue: string) => {
    const inputValueFormatted = Number(inputValue.replace(/ /g, ''))
    const ValidateValue = !!inputValueFormatted
    const separateValues = String(inputValue).split('')
    const existValues = separateValues.some(value => value === ' ')

    if (inputValue !== '' && existValues && ValidateValue) {
      setQuery(String(inputValue))

      let newOptions = [...value]

      const values = String(inputValue).split(' ')

      values.forEach(value => {
        const option = options.find(item => String(item.value) === value)

        if (option) {
          const existOption = newOptions.filter(
            item => item.value && String(item.value) === String(option.value)
          )

          if (existOption.length === 0) {
            newOptions = [...newOptions, option]
          }
        }
      })

      newOptions.length > 0 && handleOnChange(newOptions)

      document
        .querySelectorAll('.react-select__input')
        .forEach((item: any) => (item.style.visibility = 'hidden'))
    }
  }

  const handleBlur = () => {
    document
      .querySelectorAll('.react-select__input')
      .forEach((item: any) => (item.style.visibility = 'visible'))
  }

  return (
    <Box w="100%" marginTop={0 && 0}>
      <Text mb={label !== '' ? 2 : -1} fontSize="sm" color={'black'}>
        {label}
      </Text>
      <AsyncPaginate
        key={JSON.stringify(label)}
        value={value}
        loadOptions={loadOptions}
        classNamePrefix={'react-select'}
        className={isFollowUp && 'react-select__follow-up'}
        getOptionValue={option =>
          option.value != null ? option.value.toString() : ''
        }
        getOptionLabel={option => option.label}
        onChange={handleOnChange}
        isSearchable={true}
        isMulti={isMulti}
        placeholder={isLoading ? 'Carregando...' : 'Selecione...'}
        additional={{
          page: 1
        }}
        isDisabled={isLoading || isDisabled}
        isLoading={isLoading}
        isRequired={isRequired}
        closeMenuOnSelect
        onInputChange={event => handleFilterSelect(event)}
        menuPlacement="auto"
        maxHeight={200}
        css={{
          '.css-g1d714-ValueContainer': {
            maxHeight: '60px',
            overflow: 'auto'
          },
          'react-select__control': {
            background: 'red',
            'z-index': 999
          }
        }}
        onBlur={() => handleBlur()}
      />
    </Box>
  )
}

export default SelectAsyncPaginate
